module.exports = __webpack_public_path__ + "img/ic_delete.d3ff92fe.svg";